import Vue from 'vue';
import VueRouter from 'vue-router';
import isAuthenticated from '@/router/middleware/isAuthenticated';

// import public from 
import Landing from '@/views/public/index';
import Gate from '@/views/auth/gate';
import PublicFormPage from '@/views/public/order/index';

import Public from '@/views/admin/index';
import Profile from '@/views/admin/profile/index';
import Orders from '@/views/admin/orders/list/index';
import OrdersCreate from '@/views/admin/orders/create/index';
import Chat from '@/views/admin/chat/index';
import Services from '@/views/admin/services/index';
import FAQ from '@/views/admin/faq/index';

import Auth from '@/views/auth/index';
import Login from '@/views/auth/login/index';
import Forgot from '@/views/auth/forgot/index';
import Restore from '@/views/auth/restore/index';
import Signup from '@/views/auth/signup/index';

import Confirm from '@/views/public/confirm/index';
Vue.use(VueRouter);

const routes = [{
    path: '/',
    name: 'Landing',
    component: Landing,
    redirect: to => {
      return '/client/orders';
    },
  },
  {
    path: '/gate',
    name: 'Gate',
    component: Gate,
    meta: {
      layout: 'auth'
    },
  },
  {
    path: '/confirmation',
    name: 'Confirm',
    component: Confirm,
    meta: {
      layout: 'auth'
    },
  },
  {
    path: '/public-form',
    name: 'PublicFormPage',
    component: PublicFormPage
  },
  // client routes start
  {
    path: '/client',
    name: 'Public',
    component: Public,
    redirect: to => {
      return '/client/orders';
    },
    children: [{
        path: '/client/orders',
        name: 'Orders',
        component: Orders,
        meta: {
          layout: 'client'
        },
      },
      {
        path: '/client/orders/create',
        name: 'OrdersCreate',
        component: OrdersCreate,
        meta: {
          layout: 'client'
        }
      },
      {
        path: '/client/profile',
        name: 'Profile',
        component: Profile,
        meta: {
          layout: 'client'
        }
      },
      {
        path: '/client/chat',
        name: 'Chat',
        component: Chat,
        meta: {
          layout: 'client'
        }
      },
      {
        path: '/client/services',
        name: 'Services',
        component: Services,
        meta: {
          layout: 'client'
        }
      },
      {
        path: '/client/faq',
        name: 'FAQ',
        component: FAQ,
        meta: {
          layout: 'client'
        }
      }
    ]
  },
  // client routes end

  // auth routes start
  {
    path: '/auth',
    name: 'Auth',
    component: Auth,
    children: [{
        path: '/auth/login',
        name: 'Login',
        meta: {
          layout: 'auth'
        },
        component: Login,
      },
      {
        path: '/auth/signup',
        name: 'Signup',
        meta: {
          layout: 'auth'
        },
        component: Signup
      },
      {
        path: '/auth/restore',
        name: 'Restore',
        meta: {
          layout: 'auth'
        },
        component: Restore
      },
      {
        path: '/auth/forgot',
        name: 'Forgot',
        meta: {
          layout: 'auth'
        },
        component: Forgot
      }
    ]
  },
  // auth routes end
  {
    path: '*',
    redirect: to => {
      return '/client/orders';
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach(isAuthenticated);

export default router;